module.exports = __webpack_public_path__ + "static/media/Virlybird logo.45ae4437.png";